/**
 * 분석/퍼널 이벤트명 SSoT — snake_case(GA4 집계·/ga-export 호환).
 * 게임 코드는 문자열 리터럴 대신 이 상수를 사용해 오타·표기 불일치를 막는다.
 *
 * 퍼널 단계 순서와 GA4 funnel 구성은 `docs/analytics-funnel.md` 참조.
 */
export const AnalyticsEvent = {
  /** 앱 부팅 시작(main). */
  AppLaunch: "app_launch",
  /** 게임 인스턴스 부팅 완료(첫 진입 가능). */
  GameReady: "game_ready",
  /** 신규 유저 첫 세션(저장 데이터 없음). */
  FirstSession: "first_session",
  /** 첫 발사체 발사. */
  FirstFire: "first_fire",
  /** 첫 그리드 셀 해금. */
  GridUnlock: "grid_unlock",
  /** 첫 상점/일일상점 구매. */
  FirstPurchase: "first_purchase",
  /** 챕터 클리어(chapter 파라미터). */
  ChapterClear: "chapter_clear",
  /** 환생 가능 조건 최초 도달. */
  RebirthReady: "rebirth_ready",
  /** 환생 실행(best_chapter 파라미터). */
  Rebirth: "rebirth",
  /** 상점 구매(type 파라미터: gold_box/diamond_box). */
  Purchase: "purchase",
  /** 튜토리얼 시작/스텝/완료. */
  TutorialStart: "tutorial_start",
  TutorialStep: "tutorial_step",
  TutorialComplete: "tutorial_complete",
  /** 하우스 광고 노출/클릭. */
  HouseAdImpression: "house_ad_impression",
  HouseAdClick: "house_ad_click",
  /** 설정 모달의 다른 게임 개발자 페이지 이동 클릭. */
  OtherGamesClick: "other_games_click",
  /** 보상형 광고 시청 완료/건너뜀/실패(provider 파라미터: house/levelplay). */
  RewardedAdComplete: "rewarded_ad_complete",
  RewardedAdSkip: "rewarded_ad_skip",
  RewardedAdError: "rewarded_ad_error",
  /** 활성 캠페인 0건으로 광고 없이 보상(운영 안전판 — disable 실수 진단용). */
  RewardedAdCampaignEmpty: "rewarded_ad_campaign_empty",
} as const;

export type AnalyticsEventName = (typeof AnalyticsEvent)[keyof typeof AnalyticsEvent];
